import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { color } from 'src/color/color'

// TODO: somehow breakpoints are sets to material-ui
// default values when trying to use theme ones,
// further investigation is required
const mdBreakpoint = '@media (max-width: 991px)'

export const useStyles = makeStyles((theme: Theme) => createStyles({
  icon: {
    width: '1.5rem',
    margin: theme.spacing(0, 0.5, 0, 0),
    '& path': {
      fill: color('light-blue'),
    },
  },
  link: {
    margin: theme.spacing(1, 1.25, 1, 0),
    color: color('white'),
    '&:active': {
      color: `${color('white')} !important`,
    },
    '&:focus': {
      color: `${color('white')} !important`,
    },
    '&:hover': {
      color: `${color('white')} !important`,
    },
  },
  navigation: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: theme.spacing(0, 0, 1.25),
    alignItems: 'center',
    [mdBreakpoint]: {
      justifyContent: 'space-around',
      margin: theme.spacing(0),
    },
  },
  section: {
    margin: theme.spacing(12.25, 0, 0),
    [mdBreakpoint]: {
      margin: theme.spacing(2, 0, 0),
      padding: theme.spacing(0, 2),
    },
  },
  text: {
    color: color('light-blue'),
  },
}))
